import PropTypes from "prop-types";
import ProductListItem from "./ProductListItem";

const ProductList = ({ products }) => {
	return (
		<div className="l list-view">
			<div className="flex flex-col flex-auto shrink-0 w-full collection-product-wrapper">
				<div className="grid gap-x-8 gap-y-4 grid-cols-3 product-wrapper-grid">
					{products.map((product) => (
						<ProductListItem key={product.id} product={product} />
					))}
				</div>
			</div>
		</div>
	);
};

ProductList.propTypes = {
	attributes: PropTypes.object,
	products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ProductList;
